import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-warning.png'


const _withScopeId = n => (_pushScopeId("data-v-79e4cf9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-background" }
const _hoisted_2 = { class: "alert-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "경고 아이콘"
}, null, -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "btn-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "text",
        innerHTML: _ctx.warningMessage
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass([[_ctx.warningProcessButtonText ? 'btn-white' : '', 'btn-long'], "btn-long --alert"]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setIsWarning && _ctx.setIsWarning(...args)))
        }, _toDisplayString(_ctx.waringButtonText), 3),
        _withDirectives(_createElementVNode("button", {
          class: "btn-long --alert right-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setIsProcess && _ctx.setIsProcess(...args)))
        }, _toDisplayString(_ctx.warningProcessButtonText), 513), [
          [_vShow, _ctx.warningProcessButtonText]
        ])
      ])
    ])
  ]))
}